import { LaunchDates } from '../../server/utils/launchDateConstants';
const seasonalWineClubDateGate = new Date() > LaunchDates.seasonalWineClub;
const wineClubSlug = seasonalWineClubDateGate ? 'wine-club' : 'maris-picks';

export const shopNavConfig = {
  // tastingEvent: {
  //   open: false,
  //   isVia: true,
  //   primaryTitle: 'Tasting Event',
  //   nestedItems: [],
  //   route: '/weddings',
  // },
  virtualTastings: {
    open: 'listItemVirtualTastings',
    initiallyOpen: false,
    primaryTitle: 'Virtual Tastings',
    // className: 'shopWineCypress shopWineCypress2',
    nestedItems: [
      // {
      //   title: 'May 20',
      //   route: '/shop/wine/may-20',
      //   className: '',
      // },
      // {
      //   title: 'May 22',
      //   route: '/shop/wine/may-22',
      //   className: '',
      // },
      // {
      //   title: 'May 27',
      //   route: '/shop/wine/may-27',
      //   className: '',
      // },
      // {
      //   title: 'May 29',
      //   route: '/shop/wine/may-29',
      //   className: '',
      // },
      // {
      //   title: 'June 3',
      //   route: '/shop/wine/june-3',
      //   className: '',
      // },
      // {
      //   title: 'June 5',
      //   route: '/shop/wine/june-5',
      //   className: '',
      // },
      // {
      //   title: 'June 10',
      //   route: '/shop/wine/june-10',
      //   className: '',
      // },
      // {
      //   title: 'June 12',
      //   route: '/shop/wine/june-12',
      //   className: '',
      // },
      // {
      //   title: 'June 17',
      //   route: '/shop/wine/june-17',
      //   className: '',
      // },
      // {
      //   title: 'June 19',
      //   route: '/shop/wine/june-19',
      //   className: '',
      // },
      // {
      //   title: 'June 24',
      //   route: '/shop/wine/june-24',
      //   className: '',
      // },
      // {
      //   title: 'June 26',
      //   route: '/shop/wine/june-26',
      //   className: '',
      // },
      // {
      //   title: 'July 1',
      //   route: '/shop/wine/july-1',
      //   className: '',
      // },
      // {
      //   title: 'July 8',
      //   route: '/shop/wine/july-8',
      //   className: '',
      // },
      // {
      //   title: 'July 10',
      //   route: '/shop/wine/july-10',
      //   className: '',
      // },
      // {
      //   title: 'July 15',
      //   route: '/shop/wine/july-15',
      //   className: '',
      // },
      // {
      //   title: 'July 17',
      //   route: '/shop/wine/july-17',
      //   className: '',
      // },
      // {
      //   title: 'July 22',
      //   route: '/shop/wine/july-22',
      //   className: '',
      // },
      // {
      //   title: 'July 24',
      //   route: '/shop/wine/july-24',
      //   className: '',
      // },
      // {
      //   title: 'July 29',
      //   route: '/shop/wine/july-29',
      //   className: '',
      // },
      // {
      //   title: 'July 31',
      //   route: '/shop/wine/july-31',
      //   className: '',
      // },
      // {
      //   title: 'August 5',
      //   route: '/shop/wine/august-5',
      //   className: '',
      // },
      {
        title: 'August 12',
        route: '/shop/wine/august-12',
        className: '',
      },
      {
        title: 'August 19',
        route: '/shop/wine/august-19',
        className: '',
      },
      {
        title: 'August 26',
        route: '/shop/wine/august-26',
        className: '',
      },
    ],
  },
  wines: {
    open: 'listItemWine',
    initiallyOpen: true,
    primaryTitle: 'Wine',
    className: 'shopWineCypress shopWineCypress2',
    nestedItems: [
      // {
      //   title: 'SALE',
      //   route: '/shop/wine/sale',
      //   className: 'allWineCypress',
      // },
      {
        title: 'All Wines',
        route: '/shop/wine/wine',
        className: 'allWineCypress',
      },
      // {
      //   title: 'Tasting Event Wines',
      //   isVia: true,
      //   route: '/tasting-event-wines',
      //   className: 'tastingEventWineCypress',
      // },
      // {
      //   title: 'Wine Club',
      //   isVia: true,
      //   route: '/wine-club',
      //   className: 'wineClubCypress',
      // },
      // {
      //   title: 'Sale',
      //   route: '/sale',
      //   className: 'wineSaleCypress',
      // },
      // {
      //   title: 'New',
      //   isVia: true,
      //   route: '/new-arrivals',
      //   className: 'newArrivalsCypress',
      // },
      {
        title: 'Best Selling',
        route: '/shop/wine-best-selling',
        className: 'bestSellingWineCypress',
      },
      {
        title: 'Red',
        route: '/shop/wine/wine-red',
        className: 'redWineCypress',
      },
      {
        title: 'White',
        route: '/shop/wine/wine-white',
        className: 'whiteWineCypress',
      },
      {
        title: 'Sparkling',
        route: '/shop/wine/wine-sparkling',
        className: 'sparklingWineCypress',
      },
      {
        title: 'Rosé',
        route: '/shop/wine/wine-rose',
        className: 'roseWineCypress',
      },
      {
        title: 'Mixed Packs',
        route: '/shop/wine/mixed-packs',
      },
      {
        title: 'Wine Club',
        route: `/shop/product/${wineClubSlug}`,
        className: 'marisPicksCypress',
      },
      {
        title: 'Weddings & Events',
        route: '/weddings',
      },
      {
        initiallyOpen: false,
        open: 'listItemCollection',
        primaryTitle: 'COLLECTIONS',
        nestedItems: [
          {
            title: 'Award Winning',
            route: '/shop/wine/wine-collection-award-winning',
          },
          // {
          //   title: 'Limited Edition',
          //   route: '/shop/wine/wine-collection-limited',
          // },
          {
            title: 'Glitter Bottles',
            route: '/shop/wine/wine-glitter',
          },
          {
            title: 'Vintner',
            route: '/shop/wine/wine-collection-vintner',
          },
          {
            title: 'Core',
            route: '/shop/wine/wine-collection-core',
          },
          {
            title: 'Reserve',
            route: '/shop/wine/wine-collection-reserve',
          },
          {
            title: 'Iconic',
            route: '/shop/wine/wine-collection-iconic',
          },
          // { // TODO Comment out for now since all products are Sold Out
          //   title: 'Signature',
          //   route: '/shop/wine/wine-collection-signature',
          // },
          // { // TODO Comment out for now since all products are Sold Out
          //   title: 'Mixed Packs',
          //   route: '/shop/wine/wine-collection-mixed',
          // },
        ],
      },
    ],
  },
  gifts: {
    open: 'listItemGifts',
    initiallyOpen: false,
    primaryTitle: 'Gifts',
    nestedItems: [
      {
        title: 'All Gifts',
        route: '/shop/gifts/gift',
      },
      {
        title: 'Best Selling',
        route: '/shop/gifts-best-selling',
      },
      // {
      //   title: `Mother's Day Etched Gifts`,
      //   route: '/shop/mothers-day-gifts-2019',
      // },
      {
        title: 'Gift Boxes & Crates',
        route: '/shop/gifts/gifts',
      },
      {
        title: 'Wine Gifts',
        route: '/shop/gifts/gift-wine',
      },
      {
        title: 'No Alcohol Gifts',
        route: '/shop/gifts/gift-non-alcoholic',
      },
      // {
      //   title: 'Kitchen',
      //   route: '/shop/kitchen/kitchen',
      // },
      // {
      //   title: 'Coffee',
      //   route: '/shop/coffee/coffee',
      // },
      {
        title: 'Marketplace',
        route: '/shop/gifts/gift-marketplace',
      },
      {
        title: 'Wine Accessories',
        route: '/shop/gifts/gift-wine-accessories',
      },
      {
        title: 'Swag',
        route: '/shop/gifts/gift-swag',
      },
      {
        title: 'Corporate Gifting',
        route: '/corporate',
      },
      // {
      //   initiallyOpen: false,
      //   open: 'listItemGuides',
      //   primaryTitle: 'GIFT GUIDES',
      //   nestedItems: [
      //     {
      //       title: 'For Valentines',
      //       route: '/shop/valentines-day',
      //     },
      //     {
      //       title: 'For Dads',
      //       route: '/shop/guide-for-dads',
      //     },
      //     {
      //       title: 'For Moms',
      //       route: '/shop/guide-for-moms',
      //     },
      //     {
      //       title: 'For Gals',
      //       route: '/shop/guide-for-gals',
      //     },
      //     {
      //       title: 'For Guys',
      //       route: '/shop/guide-for-guys',
      //     },
      //     {
      //       title: 'For Cabernet Lovers',
      //       route: '/shop/guide-for-cabernet',
      //     },
      //     {
      //       title: 'For Pet Lovers',
      //       route: '/shop/guide-for-pet-lovers',
      //     },
      //     {
      //       title: 'For Teachers',
      //       route: '/shop/guide-for-teachers',
      //     },
      //     {
      //       title: 'For The Host',
      //       route: '/shop/guide-for-the-host',
      //     },
      //   ],
      // },
    ],
  },
  // coffee: {
  //   open: 'listItemCoffee',
  //   initiallyOpen: false,
  //   primaryTitle: 'COFFEE',
  //   nestedItems: [
  //     {
  //       title: 'All Coffee',
  //       route: '/shop/coffee/coffee',
  //     },
  //   ],
  // },
  // kitchen: {
  //   open: 'listItemKitchen',
  //   initiallyOpen: false,
  //   primaryTitle: 'KITCHEN',
  //   nestedItems: [
  //     {
  //       title: 'All Kitchen Sets',
  //       route: '/shop/kitchen/kitchen',
  //     },
  //   ],
  // },
  preferredCustomer: {
    open: false,
    primaryTitle: 'Preferred Customer',
    nestedItems: [],
    route: '/preferred',
  },
  join: {
    open: false,
    primaryTitle: 'JOIN',
    nestedItems: [],
    route: '/join',
  },
  host: {
    open: false,
    primaryTitle: 'HOST',
    nestedItems: [],
    route: '/host',
  },
  about: {
    open: 'listItemOnehope',
    initiallyOpen: false,
    primaryTitle: 'About',
    nestedItems: [
      {
        title: 'Our Story',
        route: '/about-us',
      },
      {
        title: 'Our Impact',
        route: '/impact',
      },
      {
        title: 'Our Winemaking',
        route: '/winemaking',
      },
      // {
      //   title: 'Our Vineyard',
      //   route: '/vineyard#vineyard',
      // },
      // {
      //   title: 'Our Estate',
      //   route: '/vineyard#est8te',
      // },
      // {
      //   title: 'Our Foundation',
      //   route: 'http://www.onehopefoundation.org/',
      // },
      // {
      //   title: 'Host a Wine Tasting',
      //   isVia: true,
      //   route: '/host-a-wine-tasting',
      // },
      // {
      //   title: '2017 Year in Review',
      //   route: '/2017-year-in-review',
      // },
    ],
  },
  blog: {
    open: false,
    primaryTitle: 'BLOG',
    nestedItems: [],
    route: 'https://www.onehopewine.com/blog',
  },
  // corporate: {
  //   open: false,
  //   primaryTitle: 'CORPORATE GIFTING',
  //   nestedItems: [],
  //   route: '/corporate',
  // },
  // weddings: {
  //   open: false,
  //   primaryTitle: 'WEDDINGS & EVENTS',
  //   nestedItems: [],
  //   route: '/weddings',
  // },
  // tea: { // Sample main category add (Search for whole word "Tea")
  //   key: 'tea',
  //   open: 'listItemTea',
  //   initiallyOpen: false,
  //   primaryTitle: 'TEA',
  //   nestedItems: [
  //     {
  //       title: 'All TEA',
  //       route: '/shop/tea/tea',
  //     },
  //   ],
  // },
};
